import * as React from 'react'
import Avatar from '@mui/joy/Avatar'
import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import Card from '@mui/joy/Card'
import CardContent from '@mui/joy/CardContent'
import CardOverflow from '@mui/joy/CardOverflow'
import CardActions from '@mui/joy/CardActions'
import Typography from '@mui/joy/Typography'
import { networkCompaniesFromCanonical } from '../consts'

export const SocialNetworkCard = ({ data, onClick }) => {
    return (
        <Card sx={{ width: 320, maxWidth: '100%', boxShadow: 'lg' }}>
            <CardContent sx={{ alignItems: 'center', textAlign: 'center' }}>
                <Avatar
                    src={data.avatar_url}
                    sx={{ '--Avatar-size': '4rem' }}
                />
                <Typography level="title-lg">
                    {data.username ? data.username : data.name}
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        gap: 2,
                        mt: 2,
                        '& > button': { borderRadius: '2rem' },
                    }}
                >
                    {networkCompaniesFromCanonical(data.type).icon}
                </Box>
            </CardContent>
            <CardOverflow sx={{ bgcolor: 'background.level1' }}>
                <CardActions buttonFlex="1">
                    <Button
                        variant="solid"
                        color="danger"
                        onClick={() => onClick(data)}
                    >
                        Disconnect
                    </Button>
                </CardActions>
            </CardOverflow>
        </Card>
    )
}
